import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Textarea } from '@/components/ui/textarea';
import { t } from '@/i18n';

interface UploadInvoiceDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  file: File | null;
  onFileChange: (file: File | null) => void;
  description: string;
  onDescriptionChange: (v: string) => void;
  uploading: boolean;
  onSubmit: () => void;
}

export function UploadInvoiceDialog({
  open,
  onOpenChange,
  file,
  onFileChange,
  description,
  onDescriptionChange,
  uploading,
  onSubmit,
}: UploadInvoiceDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('invoices.upload.modalTitle')}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <input
            type="file"
            accept=".pdf,application/pdf"
            className="text-sm file:mr-3 file:rounded-md file:border file:px-3 file:py-1.5 file:text-sm"
            onChange={(e) => onFileChange(e.target.files?.[0] || null)}
          />
          {file && <p className="text-muted-foreground text-sm">{file.name}</p>}
          <Textarea
            placeholder={t('invoices.upload.descriptionPlaceholder')}
            value={description}
            onChange={(e) => onDescriptionChange(e.target.value)}
            rows={3}
            maxLength={500}
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t('common.cancel')}
          </Button>
          <Button disabled={!file || uploading} onClick={onSubmit}>
            {uploading && <Loader2 className="size-4 animate-spin" />}
            {t('invoices.upload.button')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
